import { match, P } from 'ts-pattern';

import { ApiError } from '@/shared/api/http-client';

export type UserErrorCode =
    | 'EMAIL_UNAVAILABLE'
    | 'EMAIL_UNCHANGED'
    | 'IDENTITY_CONFIRMATION_REQUIRED'
    | 'RATE_LIMITED'
    | 'WEAK_PASSWORD'
    | 'INVALID_CURRENT_PASSWORD';

type ValidationErrorTree = {
    properties?: { currentPassword?: { errors?: string[] } };
};

function hasInvalidCurrentPasswordValidationError(error: ApiError): boolean {
    const tree = error.response as ValidationErrorTree | undefined;
    return (tree?.properties?.currentPassword?.errors?.length ?? 0) > 0;
}

export function resolveUserErrorCode(error: unknown): UserErrorCode | undefined {
    if (!(error instanceof ApiError)) {
        return undefined;
    }

    const wireCode = (error.response as { message?: string } | undefined)?.message;

    return match({ status: error.status, code: wireCode })
        .with({ status: 409, code: 'EMAIL_UNAVAILABLE' }, () => 'EMAIL_UNAVAILABLE' as const)
        .with({ status: 409, code: 'EMAIL_UNCHANGED' }, () => 'EMAIL_UNCHANGED' as const)
        .with(
            { status: 422, code: 'IDENTITY_CONFIRMATION_REQUIRED' },
            () => 'IDENTITY_CONFIRMATION_REQUIRED' as const,
        )
        .with({ status: 422, code: 'WEAK_PASSWORD' }, () => 'WEAK_PASSWORD' as const)
        .with(
            { status: 422, code: P.union('INVALID_CURRENT_PASSWORD', 'CURRENT_PASSWORD_REQUIRED') },
            () => 'INVALID_CURRENT_PASSWORD' as const,
        )
        .with({ status: 429, code: 'RATE_LIMITED' }, () => 'RATE_LIMITED' as const)
        .otherwise(() =>
            hasInvalidCurrentPasswordValidationError(error)
                ? ('INVALID_CURRENT_PASSWORD' as const)
                : undefined,
        );
}
